import axios from 'axios';
import { BaseApiService } from '@/services/backend/base';

export class PersonalFl223APIService extends BaseApiService {
    constructor() {
        super('personal/fl223');
    }

    async getNoticesList(filters) {
        try {
            const response = await axios.get(this.getUrl('notices'), { params: filters });
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async getProposalsList(filters) {
        try {
            const response = await axios.get(this.getUrl('proposals'), { params: filters });
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async getProposal(id) {
        try {
            const response = await axios.get(this.getUrl(`proposals/${id}`));
            return response.data.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async getContractsList(filters) {
        try {
            const response = await axios.get(this.getUrl('contracts/list'), { params: filters });
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    getContractsXlsExport(filters) {
        return axios.post(this.getUrl('contracts/xls'), filters, { responseType: 'blob' });
    }

    async settingsGet() {
        try {
            const response = await axios.get(this.getUrl('settings'));
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async settingsStore(form) {
        try {
            await axios.post(this.getUrl('settings'), form);
            return true;
        } catch (err) {
            this.handleErrors(err);
        }
    }
}
